
// Создаём массив для хранения логов
const consoleLogs: Array<{
  type: string;
  message: string;
  timestamp: string;
}> = [];

let interceptorInitialized = false;

export function interceptConsole() {
  if (interceptorInitialized) return;
  
  const methods = ['log', 'warn', 'error', 'info'];

  methods.forEach((method) => {
    const original = (console as any)[method];
    (console as any)[method] = function (...args: any[]) {
      consoleLogs.push({
        type: method,
        message: args.map(a => {
          if (typeof a === 'object') {
            try {
              // Проверяем на DOM элементы и другие циклические структуры
              if (a instanceof Element || a instanceof HTMLElement || a instanceof Document) {
                return `[${a.constructor.name}]`;
              }
              return JSON.stringify(a);
            } catch (e) {
              // Если не удается сериализовать, возвращаем строковое представление
              return String(a);
            }
          }
          return String(a);
        }).join(' '),
        timestamp: new Date().toISOString(),
      });
      original.apply(console, args); // вызываем оригинальный метод
    };
  });
  
  interceptorInitialized = true;
}

export function getConsoleLogs() {
  return [...consoleLogs];
}

export function clearConsoleLogs() {
  consoleLogs.length = 0;
}
